const versions = {
    ui: 'b5df9a7e5ca883828f08d307dac8ec9622204222'
};

export default versions;
